import { Close, ErrorOutline } from '@mui/icons-material';
import React, { createContext, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const Context = createContext();

export const ContextProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const errorShownRef = useRef(false);

  useEffect(() => {
    const isDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(isDarkMode);
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const showError = (message) => {
    if (!errorShownRef.current) {
      setErrorMessage(message);
    }
  };

  return (
    <Context.Provider value={{
      darkMode, setDarkMode,
      showError
    }}>
      {children}
      {errorMessage &&
        <ErrorNotification
          message={errorMessage}
          setErrorMessage={setErrorMessage}
          errorShownRef={errorShownRef}
        />}
    </Context.Provider>
  );
};


const ErrorNotification = ({
  setErrorMessage,
  errorShownRef
 }) => {
 const handleClose = () => {
   setErrorMessage(null);
   errorShownRef.current = null;
 };
 const {t} = useTranslation()

  return (
    <div className="fixed top-5 right-5 bg-white text-red p-3 
                    rounded shadow-lg z-50 animate-slide-in-right">
      <p className='flex items-center gap-1'>
        <ErrorOutline />
        {/* {message} */}
        
        {t('not_success')}
        <button 
        onClick={handleClose}
        className='ml-6' 
        >
          <Close fontSize="small" />
        </button>
      </p>
    </div>
  );
};